import {
  DashboardOutlined,
  NumberOutlined,
  AuditOutlined,
  DatabaseOutlined,
  FileProtectOutlined,
  StarOutlined,
  LogoutOutlined,
  AlertOutlined,
  CheckSquareOutlined,
  FileSearchOutlined,
  NotificationOutlined,
} from '@ant-design/icons';
import { suppliers } from '../mock/suppliers';

export const ROLES = {
  GROUP: 'group',
  SUBSIDIARY: 'subsidiary',
  SUPPLIER: 'supplier',
};

export const ROLE_INFO = {
  [ROLES.GROUP]: { label: '集团管理员', color: 'red' },
  [ROLES.SUBSIDIARY]: { label: '子公司管理员', color: 'blue' },
  [ROLES.SUPPLIER]: { label: '供应商', color: 'green' },
};

// Full menu for group admin
export const GROUP_MENU_ITEMS = [
  { key: '/', icon: <DashboardOutlined />, label: '管理驾驶舱' },
  { key: '/approval', icon: <CheckSquareOutlined />, label: '审批中心' },
  {
    key: '/coding', icon: <NumberOutlined />, label: '统一编码管理',
    children: [
      { key: '/coding', label: '编码规则管理' },
    ],
  },
  {
    key: '/archive', icon: <DatabaseOutlined />, label: '供应商档案',
    children: [
      { key: '/archive', label: '供应商列表' },
      { key: '/supplier-suspension', label: '资格中止管理' },
      { key: '/blacklist', label: '黑名单管控' },
    ],
  },
  {
    key: '/admission', icon: <AuditOutlined />, label: '准入管理',
    children: [
      { key: '/admission', label: '准入列表' },
    ],
  },
  {
    key: '/performance', icon: <FileProtectOutlined />, label: '履约管理',
    children: [
      { key: '/performance', label: '执行台账' },
      { key: '/performance/inspection', label: '巡检抽检' },
      { key: '/performance/issues', label: '问题跟踪' },
    ],
  },
  { type: 'divider' },
  {
    key: '/evaluation', icon: <StarOutlined />, label: '评价分级',
    children: [
      { key: '/evaluation/template', label: '评价模板' },
      { key: '/evaluation/daily', label: '日常评价' },
      { key: '/evaluation/annual', label: '年度评价' },
      { key: '/evaluation/grading', label: '分级结果' },
    ],
  },
  {
    key: '/exit', icon: <LogoutOutlined />, label: '退出管理',
    children: [
      { key: '/exit', label: '退出列表' },
      { key: '/exit/apply', label: '退出申请' },
    ],
  },
  { key: '/risk', icon: <AlertOutlined />, label: '风险预警' },
  { key: '/announcement', icon: <NotificationOutlined />, label: '公告管理' },
  { key: '/audit-log', icon: <FileSearchOutlined />, label: '操作记录' },
];

// Subset menu for subsidiary admin (编码管理/黑名单 read-only, 年度评价子企业可操作)
export const SUBSIDIARY_MENU_ITEMS = [
  { key: '/', icon: <DashboardOutlined />, label: '管理驾驶舱' },
  { key: '/approval', icon: <CheckSquareOutlined />, label: '审批中心' },
  {
    key: '/archive', icon: <DatabaseOutlined />, label: '供应商档案',
    children: [
      { key: '/archive', label: '供应商列表' },
      { key: '/supplier-suspension', label: '资格中止管理' },
      { key: '/blacklist', label: '黑名单管控' },
    ],
  },
  {
    key: '/admission', icon: <AuditOutlined />, label: '准入管理',
    children: [
      { key: '/admission', label: '准入列表' },
      { key: '/coding/mapping', label: '批量导入' },
    ],
  },
  {
    key: '/performance', icon: <FileProtectOutlined />, label: '履约管理',
    children: [
      { key: '/performance', label: '执行台账' },
      { key: '/performance/inspection', label: '巡检抽检' },
      { key: '/performance/issues', label: '问题跟踪' },
    ],
  },
  { type: 'divider' },
  {
    key: '/evaluation', icon: <StarOutlined />, label: '评价分级',
    children: [
      { key: '/evaluation/template', label: '评价模板' },
      { key: '/evaluation/daily', label: '日常评价' },
      { key: '/evaluation/annual', label: '年度评价' },
      { key: '/evaluation/grading', label: '分级结果' },
    ],
  },
  {
    key: '/exit', icon: <LogoutOutlined />, label: '退出管理',
    children: [
      { key: '/exit', label: '退出列表' },
      { key: '/exit/apply', label: '退出申请' },
    ],
  },
  { key: '/risk', icon: <AlertOutlined />, label: '风险预警' },
  { key: '/announcement', icon: <NotificationOutlined />, label: '公告管理' },
  { key: '/audit-log', icon: <FileSearchOutlined />, label: '操作记录' },
];

// Mock supplier users — 手机号唯一（一个手机号仅关联一个供应商）；
// 支持手机号验证码登录，或用户名/邮箱/统一编码 + 密码登录
const demoSuppliers = suppliers.slice(0, 3);
const SUPPLIER_USERS = demoSuppliers.map((supplier, index) => {
  const demoPhone = `1380013800${index + 1}`;
  const demoEmail = supplier.supplierEmail || `supplier${index + 1}@example.com`;
  return {
    value: supplier.name,
    label: supplier.name,
    supplierId: supplier.id,
    unifiedCode: supplier.unifiedCode,
    supplierCode: supplier.code,
    phone: demoPhone,
    email: demoEmail,
    password: '123456',
    businessType: supplier.type,
  };
});

export const normalizeIdentifier = (value = '') => value.trim().replace(/\s+/g, '').toUpperCase();

export const detectIdentifierType = (value = '') => {
  const raw = value.trim();
  const normalized = normalizeIdentifier(raw);
  if (/^1[3-9]\d{9}$/.test(raw)) return 'phone';
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) return 'email';
  if (/^CRRG-/i.test(raw)) return 'supplierCode';
  if (/^[0-9A-Z]{18}$/.test(normalized)) return 'unifiedCode';
  return 'unknown';
};

export const maskPhone = (phone = '') => phone ? phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : '-';

export const maskEmail = (email = '') => {
  if (!email || !email.includes('@')) return '-';
  const [name, domain] = email.split('@');
  return `${name.slice(0, 1)}***@${domain}`;
};

export const MOCK_USERS = [
  {
    id: 'group_1',
    name: '集团管理员',
    username: 'admin',
    role: ROLES.GROUP,
    label: '集团管理员',
  },
  // 二级板块（审批单位）
  { id: 'sub_seg_recycle', name: '再生资源板块 管理员', username: 'seg1', role: ROLES.SUBSIDIARY, subsidiary: 'seg_recycle', subsidiaryName: '再生资源板块', label: '再生资源板块' },
  { id: 'sub_seg_metal', name: '有色金属板块 管理员', username: 'seg2', role: ROLES.SUBSIDIARY, subsidiary: 'seg_metal', subsidiaryName: '有色金属板块', label: '有色金属板块' },
  { id: 'sub_seg_battery', name: '电池与新能源板块 管理员', username: 'seg3', role: ROLES.SUBSIDIARY, subsidiary: 'seg_battery', subsidiaryName: '电池与新能源板块', label: '电池与新能源板块' },
  { id: 'sub_seg_fiber', name: '绿色纤维板块 管理员', username: 'seg4', role: ROLES.SUBSIDIARY, subsidiary: 'seg_fiber', subsidiaryName: '绿色纤维板块', label: '绿色纤维板块' },
  // 三级子公司（提报单位）
  { id: 'sub_1', name: '资环链金再生资源公司 管理员', username: 'sub1', role: ROLES.SUBSIDIARY, subsidiary: 'subsidiary_1', subsidiaryName: '资环链金再生资源公司', label: '资环链金再生资源公司' },
  { id: 'sub_3', name: '电池有限公司 管理员', username: 'sub3', role: ROLES.SUBSIDIARY, subsidiary: 'subsidiary_3', subsidiaryName: '电池有限公司', label: '电池有限公司' },
  { id: 'sub_4', name: '有色金属投资公司 管理员', username: 'sub4', role: ROLES.SUBSIDIARY, subsidiary: 'subsidiary_4', subsidiaryName: '有色金属投资公司', label: '有色金属投资公司' },
  { id: 'sub_6', name: '绿色纤维有限公司 管理员', username: 'sub6', role: ROLES.SUBSIDIARY, subsidiary: 'subsidiary_6', subsidiaryName: '绿色纤维有限公司', label: '绿色纤维有限公司' },
  // 四级分公司（提报单位）
  { id: 'sub_east', name: '华东再生分公司 管理员', username: 'sub_east', role: ROLES.SUBSIDIARY, subsidiary: 'sub_east', subsidiaryName: '华东再生分公司', label: '华东再生分公司' },
  ...SUPPLIER_USERS.map((sup, index) => ({
    id: `supplier_${index + 1}`,
    supplierId: sup.supplierId,
    name: sup.label,
    username: `supplier${index + 1}`,
    role: ROLES.SUPPLIER,
    supplierName: sup.value,
    unifiedCode: sup.unifiedCode,
    supplierCode: sup.supplierCode,
    phone: sup.phone,
    email: sup.email,
    password: sup.password,
    businessType: sup.businessType,
    label: sup.label,
  })),
];

// 手机号验证码登录：手机号唯一，直接定位供应商
export const findSupplierByPhone = (phone = '') => {
  const raw = phone.trim();
  return MOCK_USERS.find((u) => u.role === ROLES.SUPPLIER && u.phone === raw);
};

// 账号 + 密码登录：用户名 / 邮箱 / 统一社会信用代码 / 集团统一编码 + 密码
export const findSupplierPasswordLoginUser = (account = '', password = '') => {
  const raw = account.trim();
  const normalized = normalizeIdentifier(raw);
  return MOCK_USERS.find((u) => {
    if (u.role !== ROLES.SUPPLIER) return false;
    const accountMatch = u.username === raw.toLowerCase()
      || (u.email || '').toLowerCase() === raw.toLowerCase()
      || normalizeIdentifier(u.unifiedCode) === normalized
      || normalizeIdentifier(u.supplierCode) === normalized;
    return accountMatch && u.password === password;
  });
};
